// Astrea Ops Platform - live updates and presence (3 Oct 2026)
//
// subscribeProjectChanges: Supabase Realtime on the projects table (see
// 20261003000002_project_live_sync.sql). Every save of a project - whichever tab it came
// from - rewrites its projects row, so this one table is the signal that something changed;
// the app then reloads and merges. RLS applies, so people only hear about projects they can read.
//
// joinPresence: who has which project open, and whether they are editing. Presence is
// held in memory by Realtime only (nothing is stored); it disappears when a window closes.
import { supabase } from './supabaseClient';

export function subscribeProjectChanges(onChange) {
  const ch = supabase
    .channel('projects-live')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'projects' }, payload => {
      const row = payload.new && payload.new.id ? payload.new : payload.old || {};
      onChange({
        type: payload.eventType,
        id: row.id || null,
        rev: payload.new && payload.new.rev != null ? Number(payload.new.rev) : null,
      });
    })
    .subscribe();
  return () => { supabase.removeChannel(ch); };
}

export function joinPresence(initial, onSync) {
  const key = (initial.userId || 'anon') + ':' + Math.random().toString(36).slice(2, 10);
  let state = { ...initial };
  let ready = false;
  const ch = supabase.channel('astrea-presence', { config: { presence: { key } } });
  ch.on('presence', { event: 'sync' }, () => {
    const st = ch.presenceState();
    const list = [];
    Object.entries(st).forEach(([k, arr]) => (arr || []).forEach(x => list.push({ ...x, key: k })));
    onSync(list);
  }).subscribe(status => {
    if (status === 'SUBSCRIBED') { ready = true; ch.track(state).catch(() => {}); }
  });
  return {
    key,
    update(next) { state = { ...state, ...next }; if (ready) ch.track(state).catch(() => {}); },
    leave() { supabase.removeChannel(ch); },
  };
}
